import { FC } from "react";
import { Stack } from "@/ui/components/layout";
import {
  SkeletonBlock,
} from "@/ui/components/primitives/Skeleton/SkeletonBlock";

export const OfferCardSkeleton: FC = () => (
  <Stack data-component="OfferCardSkeleton" className="bg-sys-white p-4 rounded-sys-lg">
    <SkeletonBlock />
  </Stack>
);
